import { render, staticRenderFns } from "./print-details.vue?vue&type=template&id=5b185930&"
import script from "./print-details.vue?vue&type=script&lang=js&"
export * from "./print-details.vue?vue&type=script&lang=js&"
import style0 from "./print-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b185930')) {
      api.createRecord('5b185930', component.options)
    } else {
      api.reload('5b185930', component.options)
    }
    module.hot.accept("./print-details.vue?vue&type=template&id=5b185930&", function () {
      api.rerender('5b185930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/print-details.vue"
export default component.exports